// extracted by mini-css-extract-plugin
module.exports = {"links":"Links_links__3vfBh","linksWrapper":"Links_linksWrapper__Cb2Ih"};